<template>
  <div>
    <b-modal ref="addActivityNoteModal" size="lg" title="Add Activity/Note">
      <template v-slot:modal-header="{ close }">
        <div class="row" style="width: 100%;">
          <div class="col-12">
            <div>
              <i class="material-icons float-left" style="font-size: 42px;margin-right: 8px;color: #303032;">
                add_circle
              </i>
            </div>
            <div class="wd-modal-subheader">
              <h3 style="font-size: 18px;font-weight: 300;color: #303032;margin: 0;">Add Activity/Note</h3>
            </div>
            <button type="button" class="close" @click="close()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </template>

      <div class="wd-modal-body">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :width="50"
                 :height="50"
                 :is-full-page="false">
        </loading>

        <div class="row">
          <div class="col-md-6">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="activity">Activity*</label>
              <b-form-select v-model="formData.activity" :options="activityOptions" class="form-control">
                <option :value="null">Select Activity</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="type">Type*</label>
              <div class="wd-v-multi-select">
                <multiselect id="type" select-label="Click to select" deselect-label="Click to remove"
                  v-model="formData.type" :options="['Accounting', 'Estimating', 'Production']"
                  :multiple="true" :close-on-select="false" :clear-on-select="false"
                  placeholder="Please Select">
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="contact">Contact</label>
              <b-form-select v-model="formData.contact" :options="contactOptions" class="form-control">
                <option :value="null">Select Contact</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="wd-checkbox" style="margin: 17px 0;">
              <label>
                <input type="checkbox" v-model="formData.followUp" />
                <span class="checkbox-decorator">
                  <span class="check"></span>
                </span>
                Follow Up
              </label>
            </div>
          </div>

          <div class="col-md-6" v-if="formData.followUp">
            <div class="wd-v-select">
              <label class="wd-v-select-label" for="user">Assigned To*</label>
              <b-form-select v-model="formData.assignedTo" :options="userOptions" class="form-control">
                <option :value="null">Select User</option>
              </b-form-select>
            </div>
          </div>

          <div class="col-md-6" v-if="formData.followUp">
            <div class="wd-webix-input">
              <label for="deadline" class="wd-v-select-label">Deadline*</label>
              <b-form-input type="date" v-model="formData.deadline" class="form-control"></b-form-input>
            </div>
          </div>

          <div class="col-md-12">
            <div class="wd-textarea">
              <label for="note">Details*</label>
              <textarea v-model="formData.note" rows="5" maxlength="10000" class="form-control"></textarea>
              <div class="text-right text-muted" v-if="formData.note">{{ formData.note.length }}/10000</div>
              <div class="text-right text-muted" v-else>0/10000</div>
            </div>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
        <button type="button" class="btn btn-primary" @click="saveActivity" :disabled="isSaving">
          <i v-if="isSaving" class="fa fa-spinner fa-spin mr-2"></i>Save
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CommonConstants from '@/constants/constants.js'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'

export default {
  name: 'AddActivityNoteModal',
  components: {
    Loading,
    Multiselect
  },
  props: {
    jobId: {
      type: [String, Number],
      required: true
    },
    activities: {
      type: Array,
      default: () => []
    },
    contacts: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  emits: ['activityAdded'],
  data() {
    return {
      constants: CommonConstants,
      isLoading: false,
      isSaving: false,
      formData: {
        activity: null,
        type: [],
        contact: null,
        followUp: false,
        assignedTo: null,
        deadline: null,
        note: ''
      }
    }
  },
  computed: {
    header() {
      return {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
    },
    activityOptions() {
      if (!this.activities || this.activities.length === 0) {
        return []
      }
      return this.activities.map(a => ({
        value: a.id,
        text: a.value
      }))
    },
    typeOptions() {
      return [
        { value: 'Accounting', text: 'Accounting' },
        { value: 'Estimating', text: 'Estimating' },
        { value: 'Production', text: 'Production' }
      ]
    },
    contactOptions() {
      if (!this.contacts || this.contacts.length === 0) {
        return []
      }
      return this.contacts.map(c => ({
        value: c.id,
        text: c.first_name && c.last_name ? `${c.first_name} ${c.last_name}` : (c.first_name || c.last_name || 'Unknown')
      }))
    },
    userOptions() {
      if (!this.users || this.users.length === 0) {
        return []
      }
      return this.users.map(u => ({
        value: u.id,
        text: u.value
      }))
    }
  },
  methods: {
    show() {
      this.$refs.addActivityNoteModal.show()
    },
    closeModal() {
      this.resetForm()
      this.$refs.addActivityNoteModal.hide()
    },
    resetForm() {
      this.formData = {
        activity: null,
        type: null,
        contact: null,
        followUp: false,
        assignedTo: null,
        deadline: null,
        note: ''
      }
    },
    async saveActivity() {
      if (!this.validateForm()) {
        return
      }

      this.isSaving = true
      try {
        const data = {
          job_id: this.jobId,
          activity: this.formData.activity,
          type: this.formData.type,
          contact: this.formData.contact || null,
          note: this.formData.note,
          assigned: this.formData.followUp ? this.formData.assignedTo : null,
          deadline: this.formData.followUp ? this.formData.deadline : null,
          'follow-up': this.formData.followUp ? '1' : '0'
        }

        const response = await axios.post(
          this.constants.api_url + 'job/notes/create',
          data,
          this.header
        )

        if (response.data.flag) {
          this.$emit('activityAdded')
          this.closeModal()
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error saving activity: ' + (response.data.message || 'Unknown error'),
            iconColor: '#dc3545',
            didOpen: (modal) => {
              const icon = modal.querySelector('.swal2-icon')
              if (icon) {
                icon.style.margin = '20px auto 0 auto'
              }
            }
          })
        }
      } catch (error) {
        console.error('Error saving activity:', error)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error saving activity: ' + (error.response?.data?.message || error.message),
          iconColor: '#dc3545',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
      } finally {
        this.isSaving = false
      }
    },
    validateForm() {
      if (!this.formData.activity) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Activity is required',
          iconColor: '#ff9800',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
        return false
      }
      if (!this.formData.type || this.formData.type.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Type is required. Please select at least one type',
          iconColor: '#ff9800',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
        return false
      }
      if (!this.formData.note || !this.formData.note.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Details is required',
          iconColor: '#ff9800',
          didOpen: (modal) => {
            const icon = modal.querySelector('.swal2-icon')
            if (icon) {
              icon.style.margin = '20px auto 0 auto'
            }
          }
        })
        return false
      }
      if (this.formData.followUp) {
        if (!this.formData.assignedTo) {
          Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Assigned To is required when Follow Up is checked',
            iconColor: '#ff9800',
            didOpen: (modal) => {
              const icon = modal.querySelector('.swal2-icon')
              if (icon) {
                icon.style.margin = '20px auto 0 auto'
              }
            }
          })
          return false
        }
        if (!this.formData.deadline) {
          Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Deadline is required when Follow Up is checked',
            iconColor: '#ff9800',
            didOpen: (modal) => {
              const icon = modal.querySelector('.swal2-icon')
              if (icon) {
                icon.style.margin = '20px auto 0 auto'
              }
            }
          })
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.wd-modal-body {
  padding: 20px;
}

.wd-modal-subheader {
  display: inline-block;
  vertical-align: top;
  margin-top: 8px;
}

.wd-v-select-label {
  font-weight: 500;
  margin-bottom: 5px;
}

.wd-v-multi-select {
  position: relative;
  z-index: 10;
}

.wd-v-multi-select .multiselect {
  z-index: 10;
}

.wd-v-multi-select .multiselect__content-wrapper {
  z-index: 1000;
}

.wd-checkbox {
  margin: 17px 0;
}

.wd-checkbox label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
}



.wd-textarea {
  margin-bottom: 15px;
}

.wd-textarea label {
  font-weight: 500;
  margin-bottom: 5px;
  display: block;
}

.text-right {
  text-align: right;
}

.text-muted {
  color: #6c757d;
  font-size: 12px;
}
</style>

